import { useTranslation } from "react-i18next";
import useProductCompatibility from "../../../../Hooks/useProductCompatibility";
import helpers from "../../../../Utils/helpers";
import { ProductSummaryCard } from "../ProductSummary";

export function VbProductSummaryCard({ ...props }) {
    const { product } = props;
    const { t } = useTranslation();

    const compatibility = useProductCompatibility(product?.productNumber);

    const getAddons = () => {
        const addons = [];

        if (product.api || product.additionalUsersCount > 0) {
            const addon = {
                description: `${product.api ? "API" : ""}${product.api && product.additionalUsersCount > 0 ? " - " : ""}${product.additionalUsersCount > 0 ? `${product.additionalUsersCount} additional ${product.additionalUsersCount > 1 ? "users" : "user"}` : ""}`,
                initialPrice: product.addonsInitialPrice,
                recurringPrice: product.addonsRecurringPrice
            };
            addons.push(addon);
        }

        return addons;
    };

    let addons = getAddons();

    const hasMainRenewPeriod = product.mainRenewPeriod !== 0;
    const invoiceDate = hasMainRenewPeriod ? product.nextInvoiceDate : ''
    const period = hasMainRenewPeriod ? product.mainRenewPeriod : ''

    return <ProductSummaryCard product={product}>
        <ProductSummaryCard.Table>
            <ProductSummaryCard.Table.THeader>
                <th className='col-6'>{t('productsummary.main')}</th>
                <th className='col-2'>{t('productsummary.initialprice')}</th>
                <th className='col-2'>{t('productsummary.nextprice')}</th>
            </ProductSummaryCard.Table.THeader>
            <ProductSummaryCard.Table.TBody>
                <tr>
                    <td scope="row">{product.productDescription}</td>
                    <td>{helpers.currencyFormatter(product.mainInitialPrice ?? 0)}</td>
                    <td>{helpers.currencyFormatter(product.mainRecurringPrice ?? 0)}</td>
                </tr>
            </ProductSummaryCard.Table.TBody>
        </ProductSummaryCard.Table>
        {(addons && addons.length > 0) && <ProductSummaryCard.Table>
            <ProductSummaryCard.Table.THeader>
                <th className="col-6">{t('productsummary.addons')}</th>
                <th className='col-2'></th>
                <th className='col-2'></th>
            </ProductSummaryCard.Table.THeader>
            <ProductSummaryCard.Table.TBody>
                {addons.map((addon) => (
                    <tr>
                        <td scope="row">{addon.description}</td>
                        <td>{helpers.currencyFormatter(addon.initialPrice ?? 0)}</td>
                        <td>{helpers.currencyFormatter(addon.recurringPrice ?? 0)}</td>
                    </tr>
                ))}
            </ProductSummaryCard.Table.TBody>
        </ProductSummaryCard.Table>}
        <ProductSummaryCard.Table className="border-0 shadow-0">
            <ProductSummaryCard.Table.THeader>
                <th className="col-6">{t('productsummary.total')}</th>
                <th className='col-2'>{helpers.currencyFormatter(product.totalInitialPrice)}</th>
                <th className='col-2'>{helpers.currencyFormatter(product.totalRecurringPrice)}</th>
            </ProductSummaryCard.Table.THeader>
        </ProductSummaryCard.Table>
        
        <ProductSummaryCard.CompatibilityWarning compatibility={compatibility} />
        
        <div className='d-flex flex-row justify-content-end my-24 mr-24 align-items-center'>
            <div className='col-3 mr-24'>
                <div className='col-12'>
                    {period && <div className='d-flex justify-content-between mb-12'>
                        <p className='mb-0 font-family-ubuntu-semibold'>{t('productsummary.renewperiod')}</p>
                        <p className='mb-0'>{period} {t('productsummary.months')}</p>
                    </div>}
                    {invoiceDate && <div className='d-flex justify-content-between'>
                        <p className='mb-0 font-family-ubuntu-semibold'>{t('productsummary.nextinvoicedate')}</p>
                        <p className='mb-0'>{helpers.formatDate(invoiceDate)}</p>
                    </div>}
                </div>
            </div>
            <div>
                <ProductSummaryCard.Actions {...props} compatibility={compatibility} />
            </div>
        </div>
    </ProductSummaryCard>
}